import {
  CREATE_FLEET_TRIP_SUCCESS,
  FETCH_FLEET_TRIP_SUCCESS,
  GET_FLEET_TRIP_SUCCESS,
  SAVE_FLEET_TRIP_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_FLEET_TRIP_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_FLEET_TRIP_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_FLEET_TRIP_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_FLEET_TRIP_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    default:
      return state;
  }
}
